import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const previewContainerStyles = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  min-width: 400px;
  max-width: 400px;
  flex: 0;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
  color: ${theme.palette.text.primary + 'D0'};
  line-height: 1.3;
  user-select: none;
  ${theme.breakpoints.down('md')} {
    min-height: 200px;
    max-width: initial;
  }
`

export const previewMainStyles = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  min-width: 400px;
  padding: 24px;
  flex: 0;
  gap: 16px;
  max-height: 100%;
  overflow-y: auto;
  ${theme.breakpoints.down('md')} {
    min-height: 200px;
  }
`

export const previewTitleStyles = (theme: Theme, hasValue: boolean) => css`
  font-size: 1rem;
  color: ${hasValue ? '#101010' : theme.palette.text.disabled};
  padding-top: 4px;
  font-weight: 600;
  line-height: 1.5rem;
  display: flex;
  align-items: flex-end;
  ${!hasValue && 'font-style: italic;'}
`

export const previewDescriptionStyles = (theme: Theme, hasValue: boolean) => css`
  padding-bottom: 8px;
  overflow-wrap: break-word;
  ${!hasValue && `color: ${theme.palette.text.disabled}; font-style: italic;`}
`
